import { jsxs as C, jsx as o } from "@emotion/react/jsx-runtime";
import { forwardRef as h } from "react";
import { Spinner as k } from "../../../components/Spinner/Spinner.mjs";
import { useHideFocusOnClick as y } from "../../../hooks.mjs";
import { useTheme as B } from "../../../theme.mjs";
import { getButtonStyles as F, buttonSpinnerStyles as S } from "./buttonStyles.mjs";
const x = h(
  ({
    type: u = "button",
    variant: n = "primary",
    loading: r,
    disabled: i,
    children: c,
    onClick: e,
    icon: t,
    iconPosition: m = "start",
    fullWidth: l,
    ...s
  }, f) => {
    const { hideFocus: a, ...p } = y(s), { theme: d } = B();
    return /* @__PURE__ */ C(
      "button",
      {
        type: u,
        ref: f,
        "aria-disabled": i,
        css: F({ variant: n, hideFocus: a, theme: d, loading: r, fullWidth: l }),
        onClick: i || r ? void 0 : e,
        ...s,
        ...p,
        children: [
          r && /* @__PURE__ */ o(k, { size: "1rem", css: S }),
          t && m === "start" && /* @__PURE__ */ o(t, { fill: "currentColor" }),
          c,
          t && m === "end" && /* @__PURE__ */ o(t, { fill: "currentColor" })
        ]
      }
    );
  }
);
x.displayName = "Button";
function H({
  variant: u = "primary",
  loading: n,
  disabled: r,
  children: i,
  onClick: c,
  icon: e,
  iconPosition: t = "start",
  component: m,
  fullWidth: l,
  ...s
}, f) {
  const { hideFocus: a, ...p } = y(s), { theme: d } = B();
  return /* @__PURE__ */ C(
    m || "a",
    {
      ref: f,
      "aria-disabled": r,
      css: F({ variant: u, hideFocus: a, theme: d, loading: n, fullWidth: l }),
      onClick: r || n ? (b) => b.preventDefault() : c,
      ...s,
      ...p,
      children: [
        n && /* @__PURE__ */ o(k, { size: "1rem", css: S }),
        e && t === "start" && /* @__PURE__ */ o(e, { fill: "currentColor" }),
        i,
        e && t === "end" && /* @__PURE__ */ o(e, { fill: "currentColor" })
      ]
    }
  );
}
const O = h(H);
export {
  x as Button,
  O as ButtonLink
};
